module.exports = __webpack_public_path__ + "static/media/AvatarSlavcho.fb980035.png";